module.exports = __webpack_public_path__ + "static/img/birthday3.cbbfb05.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/birthday3.png
// module id = xmnX
// module chunks = 1